import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import getBusinessName from "../../common/Business";

class BusinessAreaCompetitors extends Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  state = {
    activeIndex: 0,
    rows: [],
  };

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const rows = [];
    if (props.node !== undefined) {
      const competitors = _.get(props.node, "competitors[0].competitor");
      if (competitors === undefined || competitors.lenght === 0) {
        rows.push(
          <Table.Row>
            <Table.Cell>No Nearby Businesses Found</Table.Cell>
          </Table.Row>
        );
      } else {
        _.forEach(competitors, (competitor, index) => {
          const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
          rows.push(
            <Table.Row key={`Row_Business_Area_Competitors_Name_${index}`}>
              <Table.Cell className={colorClass}>
                {getBusinessName(
                  _.get(competitor, "competitorCompanyName[0]._", ""),
                  props
                )}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Area_Competitors_Address_${index}`}>
              <Table.Cell className={colorClass}>
                {_.get(competitor, "competitorAddress[0]._")}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Area_Competitors_City_${index}`}>
              <Table.Cell className={colorClass}>{`${_.get(
                competitor,
                "competitorCity[0]._"
              )} ${_.get(competitor, "competitorState[0]._")} ${_.get(
                competitor,
                "competitorZip[0]._"
              )}`}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Area_Competitors_Type_${index}`}>
              <Table.Cell className={colorClass}>
                {`Type of business: ${_.get(
                  competitor,
                  "competitorSIC01[0]._"
                )}`}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Business_Area_Competitors_Distance_${index}`}>
              <Table.Cell className={colorClass}>
                {`Distance (Miles): ${_.get(
                  competitor,
                  "competitorDistance[0]._"
                )}`}
              </Table.Cell>
            </Table.Row>
          );
        });
      }
    }
    this.state = { rows, activeIndex: 0 };
  };

  render() {
    return (
      <Accordion fluid styled key={`Business_Section_Area_Competitors`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Business_Area_Competitors_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Area Competitors
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Business_Area_Competitors_Body`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{this.state.rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default BusinessAreaCompetitors;



// WEBPACK FOOTER //
// ./src/components/reports/Business/BusinessAreaCompetitors.js